"use client"
import React from "react";
import LoadingAnimation from "@/components/shared/LoadingAnimation";
import MapPointContent from "@/components/maps/MapPointContent";

import "@/components/events/EventParticipantGroupParticipantList.css";
import { useMediaQuery } from "react-responsive";

const EventParticipantGroupParticipantList = ({
  name,
  event,
  eventParticipantGroup,
  points
}) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const buildPointContent = (key, point) => {
    return (
      <div className="participant-content default-card-wrapper">
        <MapPointContent
          name={name}
          point={point}
          external={false}
          numbered={false}
          showTitle={true}
        />
      </div>
    );
  };
  return (
    <>
      <div style={{ marginBottom: "2rem" }} />
      <div className="container">
        <div className="event-participant-group-participant-list">
          {points && points.length > 0 && (
            <>
              {points.map((point, key) => {
                return buildPointContent(key, point);
              })}
            </>
          )}
          {points && points.length === 0 && <p>Nothing to show here.</p>}
          {!points && <LoadingAnimation />}
        </div>
      </div>
    </>
  );
};
export default EventParticipantGroupParticipantList;
